import { gql } from "@apollo/client";

export const GET_USER_BROADCASTER_CONFIG = gql`
  query GetUserBroadcasterConfig($userId: ID!) {
    getUserBroadcasterConfig(userId: $userId) {
      id
      userId
      broadcasterUsername
      permissions {
        unlimitedHeadpats
        isMod
      }
      notes
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER_BROADCASTER_CONFIG = gql`
  mutation UpdateUserBroadcasterConfig(
    $input: UpdateUserBroadcasterConfigInput!
  ) {
    updateUserBroadcasterConfig(input: $input) {
      id
      userId
      broadcasterUsername
      permissions {
        unlimitedHeadpats
        isMod
      }
      notes
      isActive
      createdAt
      updatedAt
    }
  }
`;
